import React, { useContext } from 'react';

import BookmarkListItem from './BookmarkListItem';
import { ChapterList, NoContentMessage } from 'components';
import { UserContentValuesContext } from 'contexts';

const BookmarksMenu = ({ onClose, ...props }) => {
  const userContent = useContext(UserContentValuesContext);

  const { bookmarks, bookmarksByTopLevelMarker } = userContent || {};

  return (
    <>
      {Boolean(bookmarks?.length) ? (
        <ChapterList {...props}>
          {Array.from(bookmarksByTopLevelMarker).map(
            ([chapter, bookmarks]) =>
              bookmarks.length > 0 && (
                <React.Fragment
                  key={chapter?.index ?? 'bookmark-chapterList-no-chapter'}
                >
                  <BookmarkListItem topLevelMarker={chapter} onClose={onClose}>
                    {bookmarks}
                  </BookmarkListItem>
                </React.Fragment>
              ),
          )}
        </ChapterList>
      ) : (
        <NoContentMessage
          title="No bookmarks created"
          content="To add a bookmark, select the bookmark icon in the bottom navigation bar."
          {...props}
        />
      )}
    </>
  );
};

export default BookmarksMenu;
